/**
 * Convert HTML P elements to a compatible string
 *
 * @param {string} value HTML content
 * @returns {string} content with stripped paragraphs
 */
const removeParagraphs = (value) => {
    if (!/<p(?:\s+[^>]*)*>/i.test(value)) return value;

    return value.replace(/<p(?:\s+[^>]*)*>((?:(?!<\/p>).)*)<\/p>/gi, "$1\n\n").trim();
};

/**
 * Convert value to array of paragraphs
 *
 * @param {string|string[]} value value to convert
 * @returns {string[]}
 */
export const toParagraphsArray = (value) => {
    if (Array.isArray(value)) value = value.join("\n\n");
    if (typeof value != "string") return [];

    value = removeParagraphs(value);

    return value.split("\n\n");
};

/**
 * Convert value to textarea-compatible string
 *
 * @param {string|string[]} value value to convert
 * @returns {string}
 */
export const toParagraphsString = (value) => {
    if (typeof value == "string") value = value.split("\n\n");
    if (!Array.isArray(value)) return '';

    let arr = [...value];

    arr = arr.map(removeParagraphs);

    return arr.join("\n\n");
};
